export const paypalLogPrefix = "💲 [PayPal]"
